import {createAction, ActionFunction1, Action} from 'redux-actions';
import {TabIndex} from '../QCTabsTypes';

export const ACTIVE_QC_TAB_SET = 'ACTIVE_QC_TAB_SET';

export interface QCTabsPayload {
    activeTab: TabIndex;
}

export const setActiveTabAction = createAction(ACTIVE_QC_TAB_SET, (activeTab: number): QCTabsPayload => {
    return {
        activeTab,
    };
});

export type SetActiveTab = ActionFunction1<number, Action<QCTabsPayload>>;
